import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { BoelsState } from '../../reducers.index';
import { ProductState } from '../reducers/product.reducer';

export const selectProductState = createSelector(
  fromFeature.getStoreState,
  (state: BoelsState) => state.product,
);

export const selectProductFromDictionary = (props: {
  productCode: string;
  culture: string;
}) =>
  createSelector(selectProductState, (state: ProductState) => {
    return state.entities?.[props.culture]?.[props.productCode];
  });
